// extracted by mini-css-extract-plugin
module.exports = {"editButtons":"EditButtons_editButtons__Y7zZZ","toLeft":"EditButtons_toLeft__3j_Bu"};